import { Select } from 'library/ui';
import { JobDetailOption, QualificationOption } from 'models';
import React from 'react';

export default function SingleSelect({
    options,
    value,
    onChange,
}: {
    options: QualificationOption[] | JobDetailOption[];
    value?: number;
    onChange: (id?: number) => void;
}) {
    return (
        <Select
            value={value ?? ''}
            onChange={(val) => onChange(val === '' ? undefined : Number(val))}
            options={options.map((option) => ({ key: option.id, value: option.value }))}
        />
    );
}
